export const wasAppReloaded = () => {
    if (!window.perf10t) {
        return false;
    }

    return window.perf10t.wasAppReloaded();
};
